import { clearStationState } from "./clear-station-state";
import { queryClient } from "./query-client";

/**
 * Limpia toda la sesión del usuario y lo redirige al login.
 * Usar cuando el servidor indica que faltan headers de autenticación.
 */
export const forceLogout = async (): Promise<void> => {
  queryClient.cancelQueries();
  queryClient.clear();
  await clearStationState({ preserveAuth: false });
  window.location.href = "/login";
};
